import { useEffect } from "react";
import config from "config/config";
import { useExtendedRouter } from "hooks";
import { trackUAPageViewed, trackPageView } from "utils/tracking/utils";
import type { UseGTMProps } from "./useGTM.d";

const tagManagerArgs = {
  gtmId: config.gtmCode,
};

const initializeTracking = () => {
  import("react-gtm-module").then((TagManager) => {
    TagManager.initialize(tagManagerArgs);
  });
};

const useGTM = (
  language: UseGTMProps["language"],
  pageType: UseGTMProps["pageType"],
  isTrackingLess: UseGTMProps["isTrackingLess"],
) => {
  const { pathWithoutHash: path } = useExtendedRouter();

  useEffect(() => {
    if (!isTrackingLess) {
      initializeTracking();
      trackUAPageViewed(language, pageType, path);
      trackPageView(language, pageType);
    }
  }, [language, pageType, isTrackingLess, path]);
};

export default useGTM;
